











































































































































































































import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import VueJsonPretty from 'vue-json-pretty';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import ActionBar from '@/components/action-bar/action-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import DapProjectInfoPanel from '@/modules/dap/containers/dap-project-info-panel/dap-project-info-panel.vue';
import WizardProgress from '@/modules/dap/components/wizard-progress/wizard-progress.vue';

import { IProject, ISubProject } from '@/modules/dap/interfaces';
import { Project } from '@/modules/dap/models';
import { dateService, httpService, numeralService, stringService } from '@/services';

import { CONFIG } from '@/config';
import { DAP_ROUTES } from '@/modules/dap/router';

@Component({
  components: {
    ActionBar,
    DapProjectInfoPanel,
    PageLoader,
    WizardProgress,
    VueJsonPretty
  },
  validations: {
    dapsDataSource: {
      $each: {
        percentMtdMktShareInfluence: {
          totalSum: (value: number, fields: any) => {
            return (fields.percentMtdMktShareInfluence + fields.percentMtdSegmentInfluence) === 1;
          }
        },
        percentMtdSegmentInfluence: {
          totalSum: (value: number, fields: any) => {
            return (fields.percentMtdMktShareInfluence + fields.percentMtdSegmentInfluence) === 1;
          }
        }
      }
    }
  }
})
export default class DapWizardMethodologyComposedPage extends Vue {
  $v: any;

  @Prop() projectId: number;
  @Prop() dapId: number;
  @Prop() wizardStep: number;

  public DAP_ROUTES = DAP_ROUTES;
  public project: IProject = new Project();

  public infoPanel: any = {
    visible: false,
    projectId: 0,
    dapId: 0
  };

  public currentPage: number = 1;
  public searchValue: string = '';

  public productsDataSource: Array<any> = [];
  public segmentsDataSource: Array<any> = [];
  public dapsDataSource: Array<any> = [];

  public get subProjectsView () {
    const perPage = 10;
    const projects = _(this.dapsDataSource)
      .filter((p: ISubProject) => p.id !== this.dapId)
      .filter((p: ISubProject) =>
        _.size(this.searchValue)
          ? stringService.normalize(p.name).includes(stringService.normalize(this.searchValue))
          : true
      )
      .chunk(perPage)
      .value();

    const totalPages = projects.length;
    const page = this.currentPage > totalPages ? 1 : this.currentPage;
    const pages = [page];
    const pagesTotal = totalPages < 5 ? totalPages : 5;

    if (totalPages > 1) {
      let isLeft = true;
      while (pages.length < pagesTotal) {
        if (isLeft && pages[0] > 1) {
          pages.splice(0, 0, pages[0] - 1);
        } else if (pages[pages.length - 1] < totalPages) {
          pages.push(pages[pages.length - 1] + 1);
        }
        isLeft = !isLeft;
      }
    }

    return {
      page: page,
      perPage: perPage,
      total: this.project.subProjects.length,
      totalPages,
      pages,
      data: projects[this.currentPage - 1] || []
    };
  }

  public get isTotalInfluenceLevelValid () {
    return this.isInfluenceLevelValid || _.some(this.dapsDataSource, (d: any) => d.percentMtdMktShareInfluence + d.percentMtdSegmentInfluence !== 1);
  }

  public get isInfluenceLevelValid () {
    return _.sumBy(this.dapsDataSource, (d: any) => d.percentProjection) !== 1;
  }

  public showInfoPanel (dapId: number) {
    this.infoPanel = _.assign({}, this.infoPanel, {
      visible: true,
      projectId: this.projectId,
      dapId
    });
  }

  public updateInputNumber (event: any, data: any, property: string, index: number) {
    data[property] = (Math.round(numeralService.parseToNumber(event.target.value) * 100) / 100) || 0 as any;
    if (property && index >= 0) {
      if (property === 'percentMtdMktShareInfluence') {
        data['percentMtdSegmentInfluence'] = Math.round(Math.abs(1 - data[property]) * 100) / 100;
      } else {
        data['percentMtdMktShareInfluence'] = Math.round(Math.abs(1 - data[property]) * 100) / 100;
      }
      this.$v.dapsDataSource.$each[index]['percentMtdSegmentInfluence'].$touch();
      this.$v.dapsDataSource.$each[index]['percentMtdMktShareInfluence'].$touch();
    }
  }

  @Emit('submit')
  public createDap () {
    const planInfluence = _.filter(this.dapsDataSource, (d: any) => d.percentProjection > 0);

    const req = [
      httpService.http.post(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${this.dapId}/planInfluence`, planInfluence)
    ];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        this.$router.push({
          name: DAP_ROUTES.PROJECT,
          params: {
            projectId: String(this.projectId)
          }
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getPeriodText (startAt: Date, endAt: Date) {
    return `${dateService.parseDateToString(startAt, 'MMM/YYYY')} a ${dateService.parseDateToString(endAt, 'MMM/YYYY')}`;
  }

  public created () {
    this.loadParameters();
  }

  public loadParameters () {
    const req = [
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/families`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/segments`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/pure`)
    ];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        res[0].data.forEach((d: any) => {
          d.totalInfluence = 0;
          this.$set(this.productsDataSource, this.productsDataSource.length, d);
        });
        this.segmentsDataSource = res[1].data;

        res[2].data.subProjects.forEach((s: ISubProject) => s.totalInfluence = 0);
        this.project = res[2].data;

        res[3].data.forEach((d: any) => {
          d.idSubProjectTarget = d.id;
          d.percentProjection = 0;
          d.percentMtdSegmentInfluence = 0.5;
          d.percentMtdMktShareInfluence = 0.5;
          this.$set(this.dapsDataSource, this.dapsDataSource.length, d);
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }
}
